import {GET_LANG} from "../types";
import {GET_JSON} from "../types";
import {SET_JSON} from "../types";
// const initState = {};
const reducer = (state = {}, action) => {
  let newData = {
    json: {},
  };
  let editorData = {};
  if (action.type === GET_LANG) {
    console.log("init state", state);
    newData.lang = action.lang;
    newData.dir = action.dir;
    newData.textAlign = action.textAlign;
    state = Object.assign({}, newData);
    console.log("state", state);
    return state;
  } else if (action.type === GET_JSON) {
    console.log("init state", state);
    newData = state;
    editorData.id = action.id;
    editorData.getJson = action.getJson;
    editorData.updatedCountry = action.updatedCountry;
    state = Object.assign({}, newData, editorData);
    console.log("state", state);
    return state;
  } else if (action.type === SET_JSON) {
    console.log("init state", state);
    newData = state;
    editorData.updatedJson = action.updatedJson;
    editorData.updatedCountry = action.updatedCountry;
    state = Object.assign({}, newData, editorData);
    console.log("state", state);
    return state;
  } else {
    return state;
  }
};

export default reducer;
//https://stackoverflow.com/questions/34445863/changing-state-in-redux
